import { useState, useCallback } from 'react';

const STORAGE_KEY = 'customization-session-show-visuals';

const readStorage = (): boolean => {
  try {
    return localStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    return false;
  }
};

/** Whether the products show their visuals, remembered on the workstation: hidden by default, the jig stays compact. */
export const useShowVisuals = () => {
  const [show, setShow] = useState(readStorage);

  const toggle = useCallback(() => {
    setShow((previous) => {
      const next = !previous;
      try {
        if (next) {
          localStorage.setItem(STORAGE_KEY, '1');
        } else {
          localStorage.removeItem(STORAGE_KEY);
        }
      } catch {
        // Storage unavailable (private mode): the choice only lasts for this page.
      }
      return next;
    });
  }, []);

  return [show, toggle] as const;
};
